"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPath = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.red[50]};
`;
const UnlockIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("path", { d: "M4 20.182C4 21.192 4.837 22 5.882 22h12.236C19.15 22 20 21.192 20 20.182V9.21H4v10.972z" }), (0, jsx_runtime_1.jsx)(StyledPath, { d: "M12 4.336c1.36 0 2.47 1.073 2.47 2.386V7.96h2.42V6.722C16.89 4.122 14.705 2 12 2 9.307 2 7.111 4.109 7.111 6.722v2.525H9.53V6.722c0-1.313 1.11-2.386 2.47-2.386z" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 15.813c-.956 0-1.74-.808-1.74-1.793 0-.985.784-1.793 1.74-1.793s1.74.808 1.74 1.793c0 .998-.784 1.793-1.74 1.793z", fill: "#fff" }), (0, jsx_runtime_1.jsx)("path", { d: "M12.944 15.119h-1.9v3.447h1.9v-3.447z", fill: "#fff" })] }));
exports.default = (0, IconContainer_1.default)(UnlockIcon);
//# sourceMappingURL=index.js.map